import React, { useEffect, useState } from "react";
import NotificationCardExample from "./components/details-card/details-card";
import { getAllAnnouncementData, getAllLevels } from "../../services/announcement";
import styles from "./announcement.module.css";
import CustomButton from "../../common/custom-button/custom-button";
import { Divider, Row, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import CustomSelect from "../../common/input/custom-select/custom-select";
import "./components/details-card/details-card.module.css";
import CustomTextfield from "../../common/input/custom-textfield/custom-textfield";
import AnnouncementDrawer from "./components/add-update-announcement/add-update-announcement";
import EmptyLoader from "../../components/emptyloader/emptyloader";

const { Option } = Select;

const Announcement = () => {
  const [filteredAnnouncement, setFilteredAnnouncement] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [drawerMode, setDrawerMode] = useState("add");
  const [editData, setEditData] = useState(null);
  const [allLevels, setAllLevels] = useState([]);
  const [filters, setFilters] = useState({
    search: "",
    announcement_for: "ALL",
    sort: "desc",
  });

  const AnnouncementOptions = [
    {
      label: "Teachers",
      value: "TEACHER",
    },
    {
      label: "Parents",
      value: "PARENT",
    },
    {
      label: "Students",
      value: "STUDENT",
    },
    {
      label: "All",
      value: "ALL",
    },
  ];

  const DateSortOptions = [
    {
      label: "Latest Date",
      value: "desc",
    },
    {
      label: "Oldest",
      value: "asc",
    },
  ];

  useEffect(() => {
    getAllAnnouncement();
  }, [filters, reload]);

  useEffect(() => {
    getAllLevelsData();
  }, []);

  const getAllLevelsData = async () => {
    try {
      const res = await getAllLevels();
      let extractedData = res?.data?.data?.levels.map(({ name, id }) => ({
        name,
        id,
      }));
      setAllLevels(extractedData);
    } catch (err) {
      console.log(err);
    }
  };

  const getAllAnnouncement = async () => {
    setLoading(true);
    try {
      const res = await getAllAnnouncementData(filters);
      setFilteredAnnouncement(res?.data?.data?.announcements);
    } catch (err) {
      console.log(err);
      toast.error("Error getting Announcements !");
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    const searchValue = e.target.value;
    const updatedFilters = {
      ...filters,
      search: searchValue,
    };
    setFilters(updatedFilters);
  };

  const handleAnnouncementForChange = (value) => {
    const updatedFilters = {
      ...filters,
      announcement_for: value,
    };
    setFilters(updatedFilters);
  };

  const handleDateSortChange = (value) => {
    const updatedFilters = {
      ...filters,
      sort: value,
    };
    setFilters(updatedFilters);
  };

  const showAddDrawer = () => {
    setDrawerMode("add");
    setEditData(null);
    setDrawerVisible(true);
  };

  const showEditDrawer = (announcementData) => {
    console.log("announcementData => ", announcementData);
    setDrawerMode("edit");
    setEditData(announcementData);
    setDrawerVisible(true);
  };

  const onCloseDrawer = () => {
    setDrawerVisible(false);
    setEditData(null);
    setDrawerMode("add");
  };

  return (
    <div>
      <Row
        style={{
          alignItems: "center",
          justifyContent: "space-between",
          display: "flex",
          flexWrap: "wrap",
          rowGap: "10px",
        }}
      >
        <div style={{ fontSize: "20px", fontWeight: 600 }}>Announcement</div>
        <div className={styles.filter_controls}>
          <CustomTextfield
            id={`search`}
            showRequired
            labelColor="#171717"
            prefix={<SearchOutlined />}
            showSearch
            size="large"
            value={filters.search}
            placeholder="Search by keyword"
            onChange={handleSearchChange}
          />

          <div className={styles.responsive_select}>
            <CustomSelect
              id="level_id"
              labelColor="#171717"
              placeholder="Select"
              showSearch
              size="large"
              value={filters.announcement_for}
              onChange={handleAnnouncementForChange}
            >
              {AnnouncementOptions?.map((option) => (
                <Option key={option?.value} value={option?.value}>
                  {option?.label}
                </Option>
              ))}
            </CustomSelect>
          </div>

          <div className={styles.responsive_select}>
            <CustomSelect
              id="dateselect"
              labelColor="#171717"
              placeholder="Select"
              showSearch
              size="large"
              value={filters.sort}
              onChange={handleDateSortChange}
            >
              {DateSortOptions?.map((option, index) => (
                <Option key={option?.value} value={option?.value}>
                  {option?.label}
                </Option>
              ))}
            </CustomSelect>
          </div>

          <CustomButton
            onClick={showAddDrawer}
            title="New Announcement"
            type="submit"
            style={{
              height: "40px",
              marginRight: "7px",
              marginLeft: "12px",
            }}
            variant="outlined"
          />
        </div>
      </Row>
      <Divider />

      <EmptyLoader 
        loading={loading} 
        isDataAvailable={filteredAnnouncement?.length} 
      />

      <NotificationCardExample
        announcements={filteredAnnouncement}
        setReload={() => setReload((prev) => !prev)}
        onEdit={showEditDrawer}
      />

      <AnnouncementDrawer
        visible={drawerVisible}
        onClose={onCloseDrawer}
        mode={drawerMode}
        initialData={editData}
        setReload={setReload}
        allLevels={allLevels}
      />
    </div>
  );
};

export default Announcement;
